import { Icon } from "@iconify/react";
import Navbar from "../components/navbar";
import FonSideBar from "../components/fonnSideBar";
import simCard from "../media/simcard.png";
import React from "react";
import { useNavigate } from "react-router-dom";
import wifi from "../media/wifi.png";
import axios from "axios";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import { BouncyArc } from "ldrs/react";
import "ldrs/react/BouncyArc.css";
import Swal from "sweetalert2";
import useFirebaseStore from "../store/firebasestore";
import "../css/checkout.css";
import { useParams } from "react-router-dom";
import useGenStore from "../store/genstore";

function Checkout() {
  const [activeRegion, setActiveRegion] = useState("nairobi");

  const [selectedLocation, setSelectedLocation] = useState("");
  const [deliveryFee, setDeliveryFee] = useState(0);

  const { subTotal } = useParams();

  const [phone, setPhone] = useState("");
  const [maskedPhone, setMaskedPhone] = useState("*** 000");

  const cartView = useGenStore((s) => s.cartView);

  const [error, setError] = useState("");

  const userName = useFirebaseStore((s) => s.userName);
  const userID = useFirebaseStore((s) => s.userID);
  const userEm = useFirebaseStore((s) => s.userEm);

  const [guestName, setGuestName] = useState("");
  const [guestEmail, setGuestEmail] = useState("");

  const authStatus = useFirebaseStore((s) => s.authStatus);

  const navigate = useNavigate();

  const [payLoader, setpayloader] = useState(false);

  const [grandTotal, setGrandTotal] = useState(0);

  const [delText, setText] = useState("");

  const deliveryData = {
    nairobi: [
      {
        zone: "CBD",
        price: 150,
        locations: ["Nairobi CBD"]
      },
      {
        zone: "Nairobi",
        price: 150,
        locations: ["Nairobi Environs via Matatu/Bus"]
      },
      {
        zone: "Zone A",
        price: 300,
        locations: [
          "Muthaiga",
          "Ngara",
          "Pangani",
          "Eastleigh",
          "Chiromo",
          "Gikomba",
          "Upper Hill",
          "Westlands GTC Area",
          "Nairobi Hospital",
          "Parklands",
          "State House Road",
          "South B",
          "South C"
        ]
      },
      {
        zone: "Zone B",
        price: 400,
        locations: [
          "Garden Estate",
          "USIU",
          "Thome",
          "Zimmerman",
          "Roysambu",
          "Buruburu",
          "Donholm",
          "Bahati",
          "Langata",
          "James Gichuru Rd",
          "Valley Arcade",
          "Lavington",
          "Peponi Rd"
        ]
      },
      {
        zone: "Zone C",
        price: 500,
        locations: [
          "Village Market",
          "Runda",
          "Ruaka",
          "Two Rivers Mall",
          "Ridgeways",
          "Thindigua",
          "Loresho",
          "Kitisuru",
          "Kasarani",
          "Mwiki",
          "Saika",
          "Tassia",
          "Kahawa Wendani",
          "Kahawa West",
          "Githurai",
          "JKIA",
          "Kayole",
          "Kamiti Rd",
          "Dagoretti"
        ]
      },
      {
        zone: "Zone D",
        price: 700,
        locations: [
          "Ongata Rongai",
          "Karen",
          "Ngong Town",
          "Mlolongo",
          "Kahawa Sukari",
          "Banana",
          "Kiambu Town",
          "Kikuyu",
          "Kinoo",
          "Syokimau",
          "Ruiru",
          "Njiru",
          "Ruai",
          "Athi River"
        ]
      }
    ],

    outside: [
      {
        method: "Bus Parcel",
        price: 350,
        locations: [
          "Central Kenya",
          "Rift Valley",
          "Eastern",
          "Western",
          "Nyanza",
          "Coast",
          "North Eastern"
        ]
      },
      {
        method: "Courier Services",
        price: 700,
        locations: ["G4S & Fargo Courier"]
      }
    ],

    eastAfrica: [
      {
        method: "Bus Courier",
        price: 1000,
        locations: [
          "Uganda",
          "Tanzania",
          "Rwanda",
          "Burundi"
        ]
      }
    ]
  };

  useEffect(() => {
    const subtotalAmount = parseInt(subTotal) || 0;

    setGrandTotal(
      deliveryFee + subtotalAmount
    );
  }, [deliveryFee, subTotal]);

  const toPay = async () => {
    if (
      !deliveryFee ||
      !selectedLocation ||
      !phone ||
      !delText
    ) {
      Swal.fire(
        "",
        "Complete your checkout information",
        "warning"
      );
      return;
    }

    if (!/^0[17]\d{8}$/.test(phone)) {
      Swal.fire(
        "",
        "Enter a valid 10-digit number starting with 07 or 01",
        "warning"
      );
      return;
    }

    const finalName =
      authStatus === "authenticated"
        ? userName
        : guestName.trim();

    const finalEmail =
      authStatus === "authenticated"
        ? userEm
        : guestEmail.trim();

    const finalUid =
      authStatus === "authenticated"
        ? userID
        : "guest";

    if (!finalName) {
      Swal.fire(
        "",
        "Please enter your name",
        "warning"
      );
      return;
    }

    if (!finalEmail) {
      Swal.fire(
        "",
        "Please enter your email",
        "warning"
      );
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(finalEmail)) {
      Swal.fire(
        "",
        "Please enter a valid email address",
        "warning"
      );
      return;
    }

    try {
      setpayloader(true);

      const checkoutCart =
        authStatus === "authenticated"
          ? useFirebaseStore.getState().cartItems || []
          : JSON.parse(
              localStorage.getItem("guestCartItems") || "[]"
            );

      if (!checkoutCart.length) {
        setpayloader(false);

        Swal.fire(
          "",
          "Your cart is empty. Please add an item before checkout.",
          "warning"
        );

        return;
      }

      localStorage.setItem(
        "destination",
        selectedLocation
      );

      localStorage.setItem(
        "phone",
        phone
      );

      localStorage.setItem(
        "delText",
        delText
      );

      localStorage.setItem(
        "checkoutName",
        finalName
      );

      localStorage.setItem(
        "checkoutEmail",
        finalEmail
      );

      localStorage.setItem(
        "checkoutUid",
        finalUid
      );

      localStorage.setItem(
        "checkoutCartItems",
        JSON.stringify(checkoutCart)
      );

      const resp = await axios.post(
        "https://schoollabelbackend-iwy4.onrender.com/payNow",
        {
          name: finalName,
          uid: finalUid,
          payEmail: finalEmail,
          grandTotal,
          delText
        }
      );

      console.log(
        "Paystack response:",
        resp.data
      );

      if (
        !resp.data ||
        !resp.data.status ||
        !resp.data.data ||
        !resp.data.data.authorization_url
      ) {
        setpayloader(false);

        Swal.fire(
          "",
          resp.data?.message ||
            "Unable to initialize payment",
          "error"
        );

        return;
      }

      window.location.href =
        resp.data.data.authorization_url;

    } catch (error) {
      console.error(
        "Payment initialization error:",
        error
      );

      setpayloader(false);

      Swal.fire(
        "",
        "Unable to start payment. Please try again.",
        "error"
      );
    }
  };

  return (
    <div>
      <Helmet>
        <title>
          Checkout | Complete Your Order - Custom School Labels
        </title>

        <meta
          name="description"
          content="Review and complete your custom school labels order. Enter delivery notes, confirm your details, and pay securely via M-Pesa. Free delivery available."
        />
      </Helmet>

      <FonSideBar />

      <Navbar />

      <div className="checkOutWrap">
        <div className="checkOutWrapCont">

          <div className="checkoutLeft">

            <div className="checkoutIntro">
              <h2>Checkout</h2>
              <p>Ready to pay for your items.</p>
            </div>

            <div className="checkOutData">

              <div className="contactInfoCheckout">

                <div className="ciDelivery">

                  <p>1. Where To?</p>

                  <div className="regionDest">

                    <div
                      className={`regionBox ${
                        activeRegion === "nairobi"
                          ? "regionBoxActive"
                          : ""
                      }`}
                      onClick={() =>
                        setActiveRegion("nairobi")
                      }
                    >
                      <p>Within Nairobi</p>
                    </div>

                    <div
                      className={`regionBox ${
                        activeRegion === "outside"
                          ? "regionBoxActive"
                          : ""
                      }`}
                      onClick={() =>
                        setActiveRegion("outside")
                      }
                    >
                      <p>Outside Nairobi</p>
                    </div>

                    <div
                      className={`regionBox ${
                        activeRegion === "eastAfrica"
                          ? "regionBoxActive"
                          : ""
                      }`}
                      onClick={() =>
                        setActiveRegion("eastAfrica")
                      }
                    >
                      <p>East Africa</p>
                    </div>

                  </div>

                  <div className="destNames">

                    <select
                      value={selectedLocation}
                      onChange={(e) => {
                        const [
                          location,
                          method,
                          price
                        ] = e.target.value.split("|");

                        setSelectedLocation(
                          location || ""
                        );

                        setDeliveryFee(
                          Number(price) || 0
                        );
                      }}
                    >

                      <option value="">
                        Select Delivery Location
                      </option>

                      {activeRegion === "nairobi"
                        ? deliveryData.nairobi.map(
                            (group) =>
                              group.locations.map(
                                (location) => (
                                  <React.Fragment
                                    key={`${location}-${group.price}`}
                                  >

                                    <option
                                      value={`${location}|Rider|${group.price}`}
                                    >
                                      {location} -
                                      Ksh.{" "}
                                      {group.price}
                                    </option>

                                   

                                  </React.Fragment>
                                )
                              )
                          )
                        : deliveryData[
                            activeRegion
                          ].map(
                            (group) =>
                              group.locations.map(
                                (location) => (
                                  <option
                                    key={`${location}-${group.price}`}
                                    value={`${location}|${group.method}|${group.price}`}
                                  >
                                    {location} - Ksh.{" "}
                                    {group.price}
                                  </option>
                                )
                              )
                          )}

                    </select>

                  </div>

                </div>

                <div className="ciSingle">

                  <p>2. Your Number</p>

                  <div className="ciSingleWrapInputs">

                    <div className="cwiIcon">
                      <Icon
                        icon="solar:phone-linear"
                        className="faIcon"
                      />
                    </div>

                    <div className="cwiInputWrap">

                      <input
                        type="tel"
                        placeholder="07XXXXXXXX or 01XXXXXXXX"
                        value={phone}
                        onChange={(e) => {
                          const value =
                            e.target.value;

                          if (!/^\d*$/.test(value)) {
                            return;
                          }

                          if (value.length > 10) {
                            return;
                          }

                          setPhone(value);

                          if (
                            value.length >= 2 &&
                            !/^0[17]/.test(value)
                          ) {
                            setError(
                              "Phone number must start with 07 or 01"
                            );
                          } else {
                            setError("");
                          }
                        }}
                        onBlur={() => {
                          if (
                            !/^0[17]\d{8}$/.test(
                              phone
                            )
                          ) {
                            setError(
                              "Enter a valid 10-digit number starting with 07 or 01"
                            );

                            setMaskedPhone("");
                          } else {
                            setError("");

                            const lastDigits =
                              phone.slice(-3);

                            setMaskedPhone(
                              `*** ${lastDigits}`
                            );
                          }
                        }}
                      />

                      {error && (
                        <small
                          style={{
                            color: "red"
                          }}
                        >
                          {error}
                        </small>
                      )}

                    </div>

                  </div>

                </div>

                <div className="ciSingleLarge">

                  <p>3. Delivery Notes</p>

                  <div className="ciSingleWrapInputs">

                    <div className="cwiInputWrap">

                      <textarea
                        placeholder="If your location isn't listed, select the nearest zone and specify your exact address."
                        maxLength={250}
                        value={delText}
                        onChange={(e) =>
                          setText(e.target.value)
                        }
                      ></textarea>

                    </div>

                  </div>

                </div>

                <div className="ciSingle">

                  <p>4. Name</p>

                  <div className="ciSingleWrapInputs">

                    <div className="cwiIcon">

                      <Icon
                        icon="solar:user-linear"
                        className="faIcon"
                      />

                    </div>

                    <div className="cwiInputWrap">

                      {authStatus ===
                      "authenticated" ? (

                        <input
                          type="text"
                          placeholder="Name"
                          value={userName || ""}
                          readOnly
                        />

                      ) : (

                        <input
                          type="text"
                          placeholder="Enter your name"
                          value={guestName}
                          onChange={(e) =>
                            setGuestName(
                              e.target.value
                            )
                          }
                        />

                      )}

                    </div>

                  </div>

                </div>

                <div className="ciSingle">

                  <p>5. Email</p>

                  <div className="ciSingleWrapInputs">

                    <div className="cwiIcon">

                      <Icon
                        icon="solar:letter-linear"
                        className="faIcon"
                      />

                    </div>

                    <div className="cwiInputWrap">

                      {authStatus ===
                      "authenticated" ? (

                        <input
                          type="email"
                          placeholder="Email"
                          value={userEm || ""}
                          readOnly
                        />

                      ) : (

                        <input
                          type="email"
                          placeholder="Enter your email"
                          value={guestEmail}
                          onChange={(e) =>
                            setGuestEmail(
                              e.target.value
                            )
                          }
                        />

                      )}

                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>

          <div className="checkoutRight">

            <div className="checkoutContWrapPay">

              <div className="ccpWrap">

                <div className="ccpTop">

                  <div className="ccpCardPay">

                    <div className="ccpcpTop">

                      <img
                        className="simCard"
                        src={simCard}
                        alt=""
                      />

                      <img
                        className="wifi"
                        src={wifi}
                        alt=""
                      />

                    </div>

                    <div className="ccpcpBtm">

                      <div className="ccpBtmLeft">

                        <span>
                          Mpesa No.
                        </span>

                        <p>
                          {maskedPhone}
                        </p>

                      </div>

                      <div className="ccpBtmLeft">

                        <span>
                          Customer
                        </span>

                        <p>
                          {authStatus ===
                          "authenticated"
                            ? userName
                            : guestName ||
                              "Guest User"}
                        </p>

                      </div>

                    </div>

                  </div>

                </div>

                <div className="ccpMid">

                  <div className="itemPayminiDescription">

                    <div className="imDesc">

                      <span>
                        Subtotal
                      </span>

                      <span>
                        Ksh.{" "}
                        {(
                          parseInt(subTotal) || 0
                        ).toLocaleString()}
                      </span>

                    </div>

                    <div className="imDesc">

                      <span>
                        Discount
                      </span>

                      <span>
                        Ksh. 0
                      </span>

                    </div>

                    <div className="imDesc">

                      <span>
                        Delivery Fee
                      </span>

                      <span>
                        Ksh.{" "}
                        {deliveryFee.toLocaleString()}
                      </span>

                    </div>

                    <div className="imDescgt">

                      <p>
                        Grand Total
                      </p>

                      <p>
                        Ksh.{" "}
                        {grandTotal.toLocaleString()}
                      </p>

                    </div>

                  </div>

                </div>

                <div className="ccpBtm">

                  {payLoader ? (

                    <BouncyArc
                      size="60"
                      speed="1"
                      color="#25A9E1"
                    ></BouncyArc>

                  ) : (

                    <motion.button
                      whileHover={{
                        scale: 1.01
                      }}
                      whileTap={{
                        scale: 0.8
                      }}
                      onClick={toPay}
                    >
                      Pay
                    </motion.button>

                  )}

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>
  );
}

export default Checkout;